const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumSignificantDigits: 2,
  minimumSignificantDigits: 2
});

export const formatCurrency = (value: number) => {
  if (value === 0) {
    return `$0`;
  }
  return formatter.format(value);
};
